import React, { useState, useEffect } from "react";
import SingleChoice from "./questions/SingleChoice";
import MultipleChoice from "./questions/MultipleChoice";
import TextInput from "./questions/TextInput";
import ImageUpload from "./questions/ImageUpload";
import NumberInput from "./questions/Number";

const QuestionRenderer = ({ question, answer, onAnswer, questionNumber }) => {
  const getInitialValue = () => {
    if (answer !== undefined && answer !== null) return answer;
    return question.type === "multiple" ? [] : null;
  };

  const [currentAnswer, setCurrentAnswer] = useState(getInitialValue());

  useEffect(() => {
    if (answer !== undefined && answer !== null) {
      setCurrentAnswer(answer);
    } else {
      setCurrentAnswer(question.type === "multiple" ? [] : null);
    }
  }, [answer, question.id, question.type]);

  const handleAnswerChange = (value) => {
    setCurrentAnswer(value);
    onAnswer(value);
  };

  const renderQuestion = () => {
    const commonProps = {
      question: question.question,
      value: currentAnswer,
      onChange: handleAnswerChange,
    };

    switch (question.type) {
      case "single":
        return <SingleChoice {...commonProps} options={question.options} />;
      case "multiple":
        return <MultipleChoice {...commonProps} options={question.options} />;
      case "text":
        return (
          <TextInput
            {...commonProps}
            placeholder={question.placeholder}
            multiline={false}
          />
        );
      case "text-long":
        return (
          <TextInput
            {...commonProps}
            placeholder={question.placeholder}
            multiline={true}
          />
        );
      case "number":
        return (
          <NumberInput
            {...commonProps}
            placeholder={question.placeholder}
            multiline={false}
          />
        );
      case "image":
        return <ImageUpload {...commonProps} accept={question.accept} />;
      default:
        return <p>Unknown question type</p>;
    }
  };

  return <div className="question-renderer">{renderQuestion()}</div>;
};

export default QuestionRenderer;
